<template>
    <svg class="h-5 w-5" :class="style" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" fill="currentColor" aria-hidden="true">
        <path d="M31.3,38.6l-4.8,4.8v-12.6c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5,1.5v12.6l-4.8-4.8c-.6-.6-1.5-.6-2.1,0s-.6,1.5,0,2.1l7.3,7.3c0,0,.1.1.2.2,0,0,0,0,0,0,0,0,.1,0,.2,0,0,0,0,0,0,0,0,0,.1,0,.2,0,0,0,.2,0,.3,0s.2,0,.3,0c0,0,.1,0,.2,0,0,0,0,0,0,0,0,0,.1,0,.2,0,0,0,0,0,0,0,0,0,.2-.1.2-.2l7.3-7.3c.6-.6.6-1.5,0-2.1s-1.5-.6-2.1,0Z"/>
        <path d="M18.7,11.4l4.8-4.8v12.6c0,.8.7,1.5,1.5,1.5s1.5-.7,1.5-1.5V6.6l4.8,4.8c.3.3.7.4,1,.4s.7-.1,1-.4c.6-.6.6-1.5,0-2.1l-7.3-7.3c0,0-.1-.1-.2-.2,0,0,0,0,0,0,0,0-.1,0-.2,0,0,0,0,0,0,0,0,0-.1,0-.2,0,0,0-.2,0-.3,0s-.2,0-.3,0c0,0-.1,0-.2,0,0,0,0,0,0,0,0,0-.1,0-.2,0,0,0,0,0,0,0,0,0-.2.1-.2.2l-7.3,7.3c-.6.6-.6,1.5,0,2.1.6.6,1.5.6,2.1,0Z"/>
        <path d="M33.8,23.5h-17.6c-.8,0-1.5.7-1.5,1.5s.7,1.5,1.5,1.5h17.6c.8,0,1.5-.7,1.5-1.5s-.7-1.5-1.5-1.5Z"/>
    </svg>
</template>

<script>
export default {
    props: ['style'],
    setup() {
        
    },
}
</script>